module.exports = __webpack_public_path__ + "static/banner-img-desktop-ed77c228a2f682e2cf9e6f46f61095e7.jpg";